import React from 'react';
import { speakers } from '../data/speakers';
const HERO_URL = 'https://cdn.magicpatterns.com/uploads/4mQVXyQCDaLGqFgcxpbsZV/ChatGPT_Image_Sep_16,_2026,_06_41_37_PM.png';

/**
 * The supplied banner is used whole and uncropped: it already carries the
 * Winners Mindset — Life Division logo, the seven speakers with their names,
 * and the Agent Scaling Workshop title.
 */
export function SpeakerHero() {
  return <section aria-labelledby="hero-heading" className="relative" data-id="element-48" data-mp="3frdo96ni24w7">
      <h1 id="hero-heading" className="sr-only" data-id="element-49" data-mp="3kpf2ne9zdg1c">
        Agent Scaling Workshop — Winners Mindset, Life Division
      </h1>

      <div className="relative mx-auto w-full max-w-[1600px]" data-id="element-50" data-mp="3oqqxby7porge">
        {/* Cheap radial glow instead of a large blur filter, which is costly to paint */}
        <div aria-hidden="true" className="pointer-events-none absolute inset-0" style={{
        background: 'radial-gradient(60% 55% at 50% 45%, rgba(168,85,247,0.22) 0%, transparent 70%)'
      }} data-id="element-51" data-mp="3tnqtnherefub" />
        <img src={HERO_URL} alt="Agent Scaling Workshop: Joshua Torrez, Daniela Rangel, Joseph Gonzalez, Roxibell Villazana, Guillermo Febres, Yasser Fermin y Joselyn Guzman" width={1856} height={847} fetchPriority="high" decoding="async" className="relative block h-auto w-full" style={{
        paddingTop: "37px"
      }} data-id="element-52" data-mp="268rd785lsnnr" />
      </div>

      {/* Compact readable roster for small screens, where the embedded names shrink */}
      
    </section>;
}